import { ComponentHarness } from '@angular/cdk/testing'
import { NgClass } from '@angular/common'
import { Component, computed, inject, signal } from '@angular/core'
import { MatButton, MatIconButton } from '@angular/material/button'
import { MatCard } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import { ManagerVersionStore } from '../../organisation/stores/manager-version.store'
import { WINDOW } from '../tokens/window'
import { EnvUtilities } from '../utilities/env-utilities'

@Component({
  selector: 'app-version-popover',
  templateUrl: './version-popover.component.html',
  styleUrls: ['./version-popover.component.scss'],
  imports: [MatIcon, MatCard, MatIconButton, MatButton, NgClass],
})
export class VersionPopoverComponent {
  window = inject(WINDOW)
  protected store = inject(ManagerVersionStore)

  currentVersion = computed(() => EnvUtilities.buildVersion())
  newVersionAvailable = computed(() => {
    const latest = this.store.version()
    const current = this.currentVersion()
    return latest && latest.commit !== current.commit
  })
  popoverVisible = signal(false)

  refresh() {
    this.window?.location.reload()
  }
}
export class VersionPopoverComponentHarness extends ComponentHarness {
  // noinspection JSUnusedGlobalSymbols
  static hostSelector = 'app-version-popover'

  protected getContainer = this.locatorForOptional('.container')
  protected getOpenButton = this.locatorForOptional('.open')
  protected getDismissButton = this.locatorForOptional('.dismiss')
  protected getReloadButton = this.locatorForOptional('.reload')
  protected getCurrentVersionHolder = this.locatorForOptional(
    '.version.current > span'
  )
  protected getLatestVersionHolder = this.locatorForOptional(
    '.version.latest > span'
  )

  async isVisible() {
    return !!(await this.getContainer())
  }

  async isPopoverVisible() {
    return (await this.getContainer())?.hasClass('visible')
  }

  async openPopover() {
    return (await this.getOpenButton())?.click()
  }

  async dismissPopover() {
    return (await this.getDismissButton())?.click()
  }

  async reloadBrowser() {
    return (await this.getReloadButton())?.click()
  }

  async getLatestVersion() {
    return (await this.getLatestVersionHolder())?.text()
  }

  async getCurrentVersion() {
    return (await this.getCurrentVersionHolder())?.text()
  }
}
